import React, { useEffect, useId, useRef } from "react";
import DrawerA11yWrapper from "../../ui/DrawerA11yWrapper";
import Button from "../../ui/Button";
import { colors, radius, shadows, spacing, typography } from "../../ui/tokens";
import AuditExecutionDetail from "./AuditExecutionDetail";

export default function AuditDetailDrawer({ auditId, onClose, onOpenFull }) {
  const titleId = useId();
  const closeRef = useRef(null);

  useEffect(() => {
    if (document.getElementById("audit-drawer-animations")) return;
    const styleTag = document.createElement("style");
    styleTag.id = "audit-drawer-animations";
    styleTag.innerHTML = `
@keyframes auditDrawerSlide {
  from { transform: translateX(40px); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
}
@keyframes auditDrawerFade {
  from { opacity: 0; }
  to { opacity: 1; }
}
`;
    document.head.appendChild(styleTag);
  }, []);

  if (!auditId) return null;

  return (
    <DrawerA11yWrapper
      open={Boolean(auditId)}
      onClose={onClose}
      labelledBy={titleId}
      initialFocusRef={closeRef}
      backdropStyle={overlayStyle}
      containerStyle={drawerStyle}
    >
      <div style={layoutStyle}>
        <div style={headerStyle}>
          <div id={titleId} style={{ fontSize: typography.size.lg, fontWeight: typography.weight.medium }}>
            Audit Details
          </div>
          <div style={{ display: "flex", gap: spacing.sm, alignItems: "center" }}>
            <Button
              variant="secondary"
              onClick={() => onOpenFull?.(auditId)}
              style={{ padding: "6px 12px", borderRadius: radius.sm }}
            >
              Open Full Page
            </Button>
            <Button
              onClick={onClose}
              variant="ghost"
              style={closeButtonStyle}
              aria-label="Close audit drawer"
              ref={closeRef}
            >
              ×
            </Button>
          </div>
        </div>
        <div style={contentStyle}>
          <AuditExecutionDetail auditId={auditId} inline />
        </div>
      </div>
    </DrawerA11yWrapper>
  );
}

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: colors.overlayBackdrop,
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "stretch",
  zIndex: 3000,
  animation: "auditDrawerFade 0.2s ease-out",
};

const drawerStyle = {
  width: "520px",
  maxWidth: "92vw",
  height: "100%",
  background: colors.surface,
  display: "flex",
  flexDirection: "column",
  boxShadow: shadows.lg,
  animation: "auditDrawerSlide 0.25s ease-out",
};

const layoutStyle = {
  height: "100%",
  display: "flex",
  flexDirection: "column",
};

const headerStyle = {
  padding: `${spacing.xl + spacing.sm}px ${spacing.xl * 2 - spacing.xs}px`,
  borderBottom: `1px solid ${colors.border}`,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  background: colors.surface,
  position: "sticky",
  top: 0,
  zIndex: 10,
};

const closeButtonStyle = {
  background: "transparent",
  border: "none",
  cursor: "pointer",
  fontSize: `${typography.size.lg}px`,
  color: colors.textMuted,
  padding: "4px 8px",
  borderRadius: radius.sm,
};

const contentStyle = {
  padding: spacing.xl * 2 - spacing.xs,
  overflowY: "auto",
  flex: 1,
};
